import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

// import PDPA from '../views/PDPA.vue'

import Close from '../views/Close.vue'

// import VGroupMain from '../views/VGroupMain.vue'
// import VGroup from '../views/VGroup.vue'
// import Register from '../views/Register.vue'
// import VGroupSpinWheel from '../views/VGroupSpinWheel.vue'
import Result from '../views/Result.vue'

// import VLinkedMain from '../views/VLinkedMain.vue'
// import VLinked from '../views/VLinked.vue'
import CarList from '../views/CarList.vue'
// import SpinWheel from '../views/SpinWheel.vue'
// import Stat from '../views/Stat.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Close
  },
  {
    path: '/vlinked',
    name: 'VLinked',
    component: Close
  },
  {
    path: '/pdpa',
    name: 'PDPA',
    component: Close
  },
  {
    path: '/vgroup',
    name: 'VGroup',
    component: Close
  },
  {
    path: '/vgroup_main',
    name: 'VGroupMain',
    component: Close
  },
  {
    path: '/vlinked_main',
    name: 'VLinkedMain',
    component: Close
  },
  {
    path: '/carlist',
    name: 'CarList',
    component: CarList
  },
  {
    path: '/spinwheel',
    name: 'SpinWheel',
    component: Close
  },
  {
    path: '/vgroup_spinwheel',
    name: 'VGroupSpinWheel',
    component: Close
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
  {
    path: '/register',
    name: 'Register',
    component: Close
  },
  {
    path: '/stat',
    name: 'Stat',
    component: Close
  }
  // ,
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
